import SystemLogList from '@/data/systemLog/view/SystemLogList.vue'

const list = {
  path: '/systemLog',
  name: 'systemLog-list',
  component: SystemLogList
}

export default [list]
